import { DepositsHistory } from '../interfaces/deposits-history.interface';
import { TradesHistory } from '../interfaces/trades-history.interface';
import { WithdrawalsHistory } from '../interfaces/withdrawals-history.interface';

enum TransactionsHistoryEnum {
  Deposits,
  Trades,
  Withdrawals,
}

export interface TransactionsHistorySetting {
  title: string;
  key: string;
  endpoint: string;
}

export const transactionsHistorySettings: Record<
  keyof typeof TransactionsHistoryEnum,
  TransactionsHistorySetting
> = {
  Deposits: {
    title: 'Deposits',
    key: 'deposits',
    endpoint: 'get_my_deposit_history',
  },
  Trades: {
    title: 'Trades',
    key: 'trades',
    endpoint: 'get_my_trade_history',
  },
  Withdrawals: {
    title: 'Withdrawals',
    key: 'withdrawals',
    endpoint: 'get_my_withdraw_history',
  },
};

type TransactionsHistoryStore = {
  [K in keyof typeof TransactionsHistoryEnum]: K extends 'Deposits'
    ? DepositsHistory[]
    : K extends 'Trades'
    ? TradesHistory[]
    : K extends 'Withdrawals'
    ? WithdrawalsHistory[]
    : never;
};

export const transactionsHistoryStore: TransactionsHistoryStore = {
  Deposits: [],
  Trades: [],
  Withdrawals: [],
};
